var $8ffff1f90e4445ad$exports = {};
$8ffff1f90e4445ad$exports = {
    "longPressMessage": `Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu`
};


export {$8ffff1f90e4445ad$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
